import { DateTime } from "luxon";

/**
 * Canonical display formats used across the app (charts, tooltips, lists).
 * Locale-independent on purpose: `toLocaleString` presets change with the
 * system/Luxon locale and produce inconsistent output between views.
 */
export const DATE_TIME_FORMAT = "dd/MM/yyyy HH:mm";
export const DATE_FORMAT = "dd/MM/yyyy";

export const formatDateTime = (date: DateTime): string =>
    date.toFormat(DATE_TIME_FORMAT);

export const formatDate = (date: DateTime): string =>
    date.toFormat(DATE_FORMAT);

/** Formats a unix timestamp (seconds) as `dd/MM/yyyy HH:mm`. */
export const formatUnixDateTime = (seconds: number): string =>
    formatDateTime(DateTime.fromSeconds(seconds));

/**
 * Formats an ISO date string (e.g. `2026-01-31`) as `dd/MM/yyyy`.
 * Falls back to the raw value when it cannot be parsed.
 */
export const formatIsoDate = (iso: string): string => {
    const date = DateTime.fromISO(iso);
    return date.isValid ? formatDate(date) : iso;
};
